import { ScannedCode } from './scanned-code';
import { ScannedCodeType } from './scanned-code-type';

export interface ScanCodeListDefinition {
    codeType: ScannedCodeType;
    maxLength: number | undefined;
    minLength: number;
}

export const isCodeListValid = (listDefinition: ScanCodeListDefinition, scannedCodes: ScannedCode[]) => {
    if (scannedCodes.length < listDefinition.minLength) return false;

    return !listDefinition.maxLength || scannedCodes.length <= listDefinition.maxLength;
};

export const singleActivityListDefinition: ScanCodeListDefinition = {
    codeType: 'activity',
    minLength: 1,
    maxLength: 1,
};

export const singleBatchListDefinition: ScanCodeListDefinition = {
    codeType: 'batch',
    minLength: 1,
    maxLength: 1,
};

export const singleLocationsListDefinition: ScanCodeListDefinition = {
    codeType: 'location',
    minLength: 1,
    maxLength: 1,
};

export const multipleLocationsListDefinition: ScanCodeListDefinition = {
    codeType: 'location',
    minLength: 1,
    maxLength: undefined,
};

export const singleContainerListDefinition: ScanCodeListDefinition = {
    codeType: 'container',
    minLength: 1,
    maxLength: 1,
};
export const multipleContainersListDefinition: ScanCodeListDefinition = {
    codeType: 'container',
    minLength: 1,
    maxLength: undefined,
};
